// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"6032f427","316":"db081256"}[chunkId] + ".chunk.js";
};